import React, {useState, useEffect} from "react";
import { apiElementById } from "../api";
import axios from "axios";
import ElementFormAssociation from "./ElementFormAssociation";
import ElementFormAssociationUnique from "./ElementFormAssociationUnique";

import CircularProgress from '@mui/material/CircularProgress';
import { ThemeProvider } from "@mui/material/styles";
import theme from "../style/theme.js";


const myEnv = process.env
const protocole = myEnv.REACT_APP_SERVERPROTOCOLE
const host = myEnv.REACT_APP_SERVERHOSTNAME
const port = myEnv.REACT_APP_SERVERPORT
const apiIGLS = `${protocole}${host}:${port}`


// ElementEdit Component
const ElementAssociation = (params) => {
  const {id, typeElement, typeElementAAssocier, liste} = params
  const [element, setElement] = useState(null)
  const [loading, setLoading] = useState({})
  const [erreur, setErreur] = useState(false)

    useEffect(() => {
      apiElementById(typeElement, id)
      .then(res => {
          setElement(res.reponse)
          setLoading(false)
      })
      .catch(error => {
          console.log(error)
          setLoading(false)
          setErreur(true)
      })
  }, [typeElement, id])

  let typeAssociation = "multiple"
  switch (typeElement){
    case 'donnee':
      //pour inscription et document
      if (typeElementAAssocier !== 'auteur'){
        typeAssociation = "unique"
      }
      break
    case 'document':
      // pas pour donnee ni auteur
      if (typeElementAAssocier === 'inscription'  ){
        typeAssociation = "unique"
      }
      break
    case 'inscription':
      // pas pour donnee ni document
      if (typeElementAAssocier === 'collection'  ){
        typeAssociation = "unique"
      }
      break
    case 'auteur':
    case 'collection':
    default:
      typeAssociation = "multiple"
      break
  }

  //onSubmit handler
  const onSubmit = (props) => {
    /** on commence par supprimer les associations pour les recréer
     * avec le tableau des options passés en parametre
     */
     const token = localStorage.getItem('token-access') ? localStorage.getItem('token-access') : ""
     const headers = {
      'accept': 'application/json',
      'x-access-token': token,
     }
      axios({
          method: 'get',
          url:  `${apiIGLS}/${typeElement}/${id}/del/${typeElementAAssocier}s`,
          headers: headers,
      })
      .then((reponse) => {
        if (reponse.status === 200) {
          //alert(`Element ${typeElement} ${id} dissocie de ${typeElementAAssocier}`)
          // j'enchaine avec  les associations
          for (const prop of props){
            //cas de la suppression sans reassociation
            if (prop){
              const idCourant = prop.value
              axios({
                method: 'get',
                url:  `${apiIGLS}/${typeElement}/${id}/add/${typeElementAAssocier}/${idCourant}`,
                headers: headers,
              })
              .then((reponse2) => {
                if (reponse2.status !== 200) {
                  Promise.reject()
                }
              })
              .catch((err) => alert("Un problème est survenu lors de l'association "
                  + "des associations l'element de type "
                  + `${typeElement} ${id} avec ${typeElementAAssocier} ${idCourant}`
                  + " erreur " + err.message))
              }
          }//fin boucle photos a associer
          alert(`Association effectuée`)
        } else Promise.reject();
      })
      .catch((erreur) => {
        if (erreur.response && erreur.response.status === 401){
          alert("Une erreur d'authentification a eu lieu lors de l'association"
            + " de l'element de type "
            + typeElement
            + " avec l'element de type "
            + typeElementAAssocier
            + " Erreur : "  + erreur.response.data)
        } else if (erreur.response && erreur.response.status === 403){
          alert("Une erreur d'autorisation a eu lieu lors de l'association"
            + " de l'element de type "
            + typeElement
            + " avec l'element de type "
            + typeElementAAssocier
            + " Erreur : "  + erreur.response.data)
        } else {
          alert("Une erreur a eu lieu lors de l'association"
            + " de l'element de type "
            + typeElement
            + " avec l'element de type "
            + typeElementAAssocier
            + " Erreur : "  + erreur.message)
        }
      })
  }

  if (!element) return null

  return (
    <>
      { !loading  && !erreur && element && (typeAssociation === 'multiple') && <ElementFormAssociation
        initialValues={element}
        typeElement={typeElement}
        typeElementAAssocier={typeElementAAssocier}
        liste={liste}
        onSubmit={onSubmit}
      />}
      { !loading  && !erreur && element && (typeAssociation === 'unique') && <ElementFormAssociationUnique
        initialValues={element}
        typeElement={typeElement}
        typeElementAAssocier={typeElementAAssocier}
        liste={liste}
        onSubmit={onSubmit}
      />}
      {loading  && <ThemeProvider theme={theme}><CircularProgress color="secondary"/><h3>Je charge</h3></ThemeProvider> }
      {erreur  && <h3>J'ai rencontré un problème...</h3> }
      {/*fini && <Navigate to={urlSuite} replace={true}/> */}
    </>
  )
}
export default ElementAssociation